<template>
  <div id="table-row" class="flex align-center">
    <p class="table-column">{{ folio }}</p>
    <p class="table-column">{{ invoicedAt }}</p>
    <p class="table-column">{{ rfc }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ legalName }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ amount }} MXN</p>
    <div class="table-column dspl-none-m dspl-none-sm">
      <button @click="downloadPdf" class="btn orange" :disabled="pdfLoading">Descarga</button>
    </div>
    <div class="table-column dspl-none-m dspl-none-sm">
      <button @click="downloadXml" class="btn green" :disabled="xmlLoading">Descarga</button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import request from '@/api/request'

export default {
  name: 'TableRow',
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pdfLoading: false,
      xmlLoading: false
    }
  },
  computed: {
    id () {
      return this.invoice.id
    },
    invoicedAt () {
      return dayjs(this.invoice.created_at).format('DD/MM/YYYY')
    },
    folio () {
      return this.invoice.folio
    },
    rfc () {
      return this.invoice.rfc
    },
    legalName () {
      return this.invoice.legal_name
    },
    amount () {
      return this.invoice.formatted_total
    },
    pdfFileRoute () {
      return `${process.env.VUE_APP_BASE_API}/users/invoices/${this.invoice.id}.pdf`
    },
    xmlFileRoute () {
      return `${process.env.VUE_APP_BASE_API}/users/invoices/${this.invoice.id}.xml`
    }
  },
  methods: {
    downloadPdf () {
      this.pdfLoading = true
      request({
        url: this.pdfFileRoute,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', `Factura-${this.folio}.pdf`)
        document.body.appendChild(fileLink)
        this.pdfLoading = false
        fileLink.click()
      })
    },
    downloadXml () {
      this.xmlLoading = true
      request({
        url: this.xmlFileRoute,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', `Factura-${this.folio}.xml`)
        document.body.appendChild(fileLink)
        this.xmlLoading = false
        fileLink.click()
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#table-row {
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid $grey;
  }
}

.table-column {
  text-align: center;
  margin: .75rem 0;
  width: calc(100% / 7);
}

.btn {
  border-radius: 20px;
  color: $white;
  border: 0;
  padding: 0.5em 1.5em;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.orange {
    background-color: $orange;
  }

  &.green {
    background-color: $green;
  }
}

@media screen and (max-width: 60rem) {
  .table-column {
    font-size: .75rem;
    width: calc(100% / 4)
  }
}
</style>
